import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';

export const PopupNotificationApi = {
  async list({ offset, size, sortBy, ...filters }) {
    return checkErrors(await fetchApi.api.get('manage/popup-notifications', { query: { offset, size, sortBy, ...filters } }));
  },

  async get(id) {
    return checkErrors(await fetchApi.api.get(`manage/popup-notifications/${id}`));
  },

  async check() {
    return checkErrors(await fetchApi.api.get('manage/popup-notifications/notifications-check'));
  },

  async confirm(id) {
    return checkErrors(await fetchApi.api.get(`manage/popup-notifications/notifications-confirm/${id}`));
  },

  async update(id, schema) {
    return checkErrors(await fetchApi.api.put(`manage/popup-notifications/${id}`, { data: schema }));
  },
  async create(schema) {
    return (await checkErrors(await fetchApi.api.post('manage/popup-notifications/', { data: schema }))).data;
  },
  async delete(id) {
    return checkErrors(await fetchApi.api.delete(`manage/popup-notifications/${id}`));
  },
};

export default PopupNotificationApi;
